import { map } from "nanostores";

export const $appContext = map({
	video: {
		muted: true,
	},
	pip: {
		currentTime: 0,
		videoId: undefined,
	},
});

export const $videoPlayingIndex = map({});

export function updateAppContext(key, value) {
	$appContext.setKey(key, {
		...$appContext.get()[key],
		...value,
	});
}

export function getContextValueByKey(key) {
	return $appContext.get()[key];
}
